import { render } from "./Footer.vue?vue&type=template&id=050ad8af"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\amlakplus-online\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__